import type { SceneModule } from '../_shared/types'
import YearWrapped from './YearWrapped'
import { YearWrappedEditor } from './Editor'
import { render } from './svgRender'

export const module: SceneModule = {
  id: 'year-wrapped',
  Component: YearWrapped,
  Editor: YearWrappedEditor,
  svgRender: render,
}
